<template>
  <validation-provider :rules="rules" ref="provider" :name="name" v-slot="{errors}">
    <b-form-group>
      <slot name="label">
        <label v-if="label" :class="labelClasses">
          {{label}}
        </label>
      </slot>
      <div class="tags-input__wrapper">
        <el-tag
          v-for="(tag, index) in dynamicTags"
          :key="tag + index"
          size="small"
          :type="tagType"
          :closable="true"
          :close-transition="false"
          @close="handleClose(tag)"
        >
          {{ tag }}
        </el-tag>

        <input
          v-model="value"
          type="hidden"
          :rules="$attrs.rules"
        />

        <input
          class="form-control"
          v-model="inputValue"
          ref="saveTagInput"
          size="mini"
          :placeholder="$attrs.placeholder"
          @input="onInput"
          @keydown.enter.prevent="handleInputConfirm"
          @blur="handleInputConfirm"
        />
      </div>
      <slot name="error">
        <div v-if="errors[0]" class="invalid-feedback" style="display: block;">
          {{ $t(`formError.${errors[0]}`) }}
        </div>
      </slot>
    </b-form-group>
  </validation-provider>
</template>

<script>
import { Tag } from 'element-ui';

export default {
  name: 'tags-input',
  inheritAttrs: false,
  components: {
    [Tag.name]: Tag
  },
  props: {
    value: {
      type: Array,
      default: () => [],
      description: 'List of tags'
    },
    tagType: {
      type: String,
      default: 'primary',
      description: 'Tag type (primary|danger etc)'
    },
    label: {
      type: String,
      description: "Input label (text before input)"
    },
    inputClasses: {
      type: String,
      description: "Input css classes"
    },
    rules: {
      type: [String, Array, Object],
      description: 'Vee validate validation rules',
      default: ''
    },
    successMessage: {
      type: String,
      description: "Input success message",
      default: ''
    },
    labelClasses: {
      type: String,
      description: "Input label css classes",
      default: "form-control-label"
    },
    name: {
      type: String,
      description: 'Input name (used for validation)',
      default: ''
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return {
      dynamicTags: [],
      inputVisible: false,
      inputValue: ''
    };
  },
  methods: {
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      this.$emit('change', this.dynamicTags);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      this.$refs['provider'].validate();

      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
        this.$emit('change', this.dynamicTags);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    onInput(evt) {
      this.$refs['provider'].validate();
      this.$emit('input', evt.target.value);
    }
  },
  created() {
    this.$watch(
      'value',
      newVal => {
        this.dynamicTags = [...newVal];
      },
      { immediate: true }
    );
  }
};
</script>
